/* GlobifySIM – Geräteliste für den eSIM-Check. */
window.GS_HERSTELLER = ["Apple", "Samsung", "Google", "Xiaomi", "Huawei", "Motorola", "OnePlus", "Oppo", "Honor", "Sony", "Nothing", "Fairphone", "Rakuten", "Microsoft", "Other"];
window.GS_GERAETE = [
  {
    "id": "g000",
    "marke": "Apple",
    "modell": "iPhone XS / XS Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone xs / xs max iphone xs max 10s"
  },
  {
    "id": "g001",
    "marke": "Apple",
    "modell": "iPhone XR",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone xr iphone xr 10r"
  },
  {
    "id": "g002",
    "marke": "Apple",
    "modell": "iPhone 11 / 11 Pro / 11 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 11 / 11 pro / 11 pro max iphone 11 pro max"
  },
  {
    "id": "g003",
    "marke": "Apple",
    "modell": "iPhone SE (2nd generation, 2020)",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone se (2nd generation, 2020) iphone se 2020 se2"
  },
  {
    "id": "g004",
    "marke": "Apple",
    "modell": "iPhone 12 / 12 mini / 12 Pro / 12 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 12 / 12 mini / 12 pro / 12 pro max iphone 12 mini pro max"
  },
  {
    "id": "g005",
    "marke": "Apple",
    "modell": "iPhone 13 / 13 mini / 13 Pro / 13 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 13 / 13 mini / 13 pro / 13 pro max iphone 13 mini pro max"
  },
  {
    "id": "g006",
    "marke": "Apple",
    "modell": "iPhone SE (3rd generation, 2022)",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone se (3rd generation, 2022) iphone se 2022 se3"
  },
  {
    "id": "g007",
    "marke": "Apple",
    "modell": "iPhone 14 / 14 Plus / 14 Pro / 14 Pro Max",
    "status": "ja",
    "hinweis": "US models have no SIM tray at all.",
    "such": "apple iphone 14 / 14 plus / 14 pro / 14 pro max iphone 14 plus pro max"
  },
  {
    "id": "g008",
    "marke": "Apple",
    "modell": "iPhone 15 / 15 Plus / 15 Pro / 15 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 15 / 15 plus / 15 pro / 15 pro max iphone 15 plus pro max"
  },
  {
    "id": "g009",
    "marke": "Apple",
    "modell": "iPhone 16 / 16 Plus / 16 Pro / 16 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 16 / 16 plus / 16 pro / 16 pro max iphone 16 plus pro max"
  },
  {
    "id": "g010",
    "marke": "Apple",
    "modell": "iPhone 16e",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 16e iphone 16e"
  },
  {
    "id": "g011",
    "marke": "Apple",
    "modell": "iPhone Air",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone air iphone air"
  },
  {
    "id": "g012",
    "marke": "Apple",
    "modell": "iPhone 17 / 17 Pro / 17 Pro Max",
    "status": "ja",
    "hinweis": "",
    "such": "apple iphone 17 / 17 pro / 17 pro max iphone 17 pro max"
  },
  {
    "id": "g013",
    "marke": "Apple",
    "modell": "iPhone X / 8 / 7 and older",
    "status": "nein",
    "hinweis": "There is no eSIM before the iPhone XS.",
    "such": "apple iphone x / 8 / 7 and older iphone x 8 7 6 alt"
  },
  {
    "id": "g014",
    "marke": "Apple",
    "modell": "iPhone (mainland China, dual SIM tray models)",
    "status": "nein",
    "hinweis": "Devices sold in mainland China use two physical SIM cards.",
    "such": "apple iphone (mainland china, dual sim tray models) china dual sim iphone"
  },
  {
    "id": "g015",
    "marke": "Apple",
    "modell": "iPad Pro / iPad Air / iPad / iPad mini (Wi-Fi + Cellular)",
    "status": "ja",
    "hinweis": "Only the cellular versions, 2018 and later.",
    "such": "apple ipad pro / ipad air / ipad / ipad mini (wi-fi + cellular) ipad pro air mini tablet"
  },
  {
    "id": "g016",
    "marke": "Apple",
    "modell": "Apple Watch (Cellular)",
    "status": "teilweise",
    "hinweis": "Only with a plan from your own operator, not with a travel eSIM.",
    "such": "apple apple watch (cellular) apple watch uhr"
  },
  {
    "id": "g017",
    "marke": "Samsung",
    "modell": "Galaxy S20 / S20+ / S20 Ultra",
    "status": "teilweise",
    "hinweis": "Not in every country; Korean and some dual-SIM versions have no eSIM.",
    "such": "samsung galaxy s20 / s20+ / s20 ultra s20 plus ultra"
  },
  {
    "id": "g018",
    "marke": "Samsung",
    "modell": "Galaxy S21 / S21+ / S21 Ultra",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy s21 / s21+ / s21 ultra s21 plus ultra"
  },
  {
    "id": "g019",
    "marke": "Samsung",
    "modell": "Galaxy S22 / S22+ / S22 Ultra",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy s22 / s22+ / s22 ultra s22 plus ultra"
  },
  {
    "id": "g020",
    "marke": "Samsung",
    "modell": "Galaxy S23 / S23+ / S23 Ultra / S23 FE",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy s23 / s23+ / s23 ultra / s23 fe s23 plus ultra fe"
  },
  {
    "id": "g021",
    "marke": "Samsung",
    "modell": "Galaxy S24 / S24+ / S24 Ultra / S24 FE",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy s24 / s24+ / s24 ultra / s24 fe s24 plus ultra fe"
  },
  {
    "id": "g022",
    "marke": "Samsung",
    "modell": "Galaxy S25 / S25+ / S25 Ultra / S25 Edge",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy s25 / s25+ / s25 ultra / s25 edge s25 plus ultra edge"
  },
  {
    "id": "g023",
    "marke": "Samsung",
    "modell": "Galaxy S20 FE / S21 FE",
    "status": "teilweise",
    "hinweis": "S21 FE yes, S20 FE depends on the country.",
    "such": "samsung galaxy s20 fe / s21 fe s20 fe s21 fe"
  },
  {
    "id": "g024",
    "marke": "Samsung",
    "modell": "Galaxy Note 20 / Note 20 Ultra",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy note 20 / note 20 ultra note20 note 20 ultra"
  },
  {
    "id": "g025",
    "marke": "Samsung",
    "modell": "Galaxy Z Fold 2 to Z Fold 7",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy z fold 2 to z fold 7 z fold falt"
  },
  {
    "id": "g026",
    "marke": "Samsung",
    "modell": "Galaxy Z Flip to Z Flip 7",
    "status": "ja",
    "hinweis": "",
    "such": "samsung galaxy z flip to z flip 7 z flip klapp"
  },
  {
    "id": "g027",
    "marke": "Samsung",
    "modell": "Galaxy A54 / A55 / A56",
    "status": "teilweise",
    "hinweis": "Depends on country and version; check the SIM manager.",
    "such": "samsung galaxy a54 / a55 / a56 a54 a55 a56"
  },
  {
    "id": "g028",
    "marke": "Samsung",
    "modell": "Galaxy A36 / A35 / A34",
    "status": "nein",
    "hinweis": "This series usually has no eSIM.",
    "such": "samsung galaxy a36 / a35 / a34 a34 a35 a36"
  },
  {
    "id": "g029",
    "marke": "Samsung",
    "modell": "Galaxy Watch (LTE)",
    "status": "teilweise",
    "hinweis": "Only with a plan from your own operator.",
    "such": "samsung galaxy watch (lte) galaxy watch uhr"
  },
  {
    "id": "g030",
    "marke": "Google",
    "modell": "Pixel 3 / 3 XL / 3a / 3a XL",
    "status": "teilweise",
    "hinweis": "eSIM only with certain operators and countries.",
    "such": "google pixel 3 / 3 xl / 3a / 3a xl pixel 3 3a xl"
  },
  {
    "id": "g031",
    "marke": "Google",
    "modell": "Pixel 4 / 4a / 4 XL",
    "status": "ja",
    "hinweis": "Japanese 4a units have no eSIM.",
    "such": "google pixel 4 / 4a / 4 xl pixel 4 4a xl"
  },
  {
    "id": "g032",
    "marke": "Google",
    "modell": "Pixel 5 / 5a",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 5 / 5a pixel 5 5a"
  },
  {
    "id": "g033",
    "marke": "Google",
    "modell": "Pixel 6 / 6a / 6 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 6 / 6a / 6 pro pixel 6 6a pro"
  },
  {
    "id": "g034",
    "marke": "Google",
    "modell": "Pixel 7 / 7a / 7 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 7 / 7a / 7 pro pixel 7 7a pro"
  },
  {
    "id": "g035",
    "marke": "Google",
    "modell": "Pixel 8 / 8a / 8 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 8 / 8a / 8 pro pixel 8 8a pro"
  },
  {
    "id": "g036",
    "marke": "Google",
    "modell": "Pixel 9 / 9a / 9 Pro / 9 Pro Fold",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 9 / 9a / 9 pro / 9 pro fold pixel 9 9a pro fold"
  },
  {
    "id": "g037",
    "marke": "Google",
    "modell": "Pixel 10 / 10 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "google pixel 10 / 10 pro pixel 10 pro"
  },
  {
    "id": "g038",
    "marke": "Google",
    "modell": "Pixel 2 and older",
    "status": "nein",
    "hinweis": "",
    "such": "google pixel 2 and older pixel 2 alt"
  },
  {
    "id": "g039",
    "marke": "Xiaomi",
    "modell": "Xiaomi 12T Pro",
    "status": "ja",
    "hinweis": "",
    "such": "xiaomi xiaomi 12t pro 12t pro"
  },
  {
    "id": "g040",
    "marke": "Xiaomi",
    "modell": "Xiaomi 13 / 13 Pro / 13T / 13T Pro / 13 Lite",
    "status": "ja",
    "hinweis": "",
    "such": "xiaomi xiaomi 13 / 13 pro / 13t / 13t pro / 13 lite 13 pro 13t lite"
  },
  {
    "id": "g041",
    "marke": "Xiaomi",
    "modell": "Xiaomi 14 / 14 Pro / 14T / 14T Pro / 14 Ultra",
    "status": "ja",
    "hinweis": "",
    "such": "xiaomi xiaomi 14 / 14 pro / 14t / 14t pro / 14 ultra 14 pro 14t ultra"
  },
  {
    "id": "g042",
    "marke": "Xiaomi",
    "modell": "Xiaomi 15 / 15 Pro / 15T / 15T Pro / 15 Ultra",
    "status": "ja",
    "hinweis": "",
    "such": "xiaomi xiaomi 15 / 15 pro / 15t / 15t pro / 15 ultra 15 pro 15t ultra"
  },
  {
    "id": "g043",
    "marke": "Xiaomi",
    "modell": "Redmi Note (all series)",
    "status": "nein",
    "hinweis": "Redmi Note devices generally have no eSIM.",
    "such": "xiaomi redmi note (all series) redmi note 12 13 14"
  },
  {
    "id": "g044",
    "marke": "Xiaomi",
    "modell": "Poco (all series)",
    "status": "nein",
    "hinweis": "",
    "such": "xiaomi poco (all series) poco x f m"
  },
  {
    "id": "g045",
    "marke": "Huawei",
    "modell": "P40 / P40 Pro",
    "status": "ja",
    "hinweis": "No Google services; the eSIM can be set up by QR code.",
    "such": "huawei p40 / p40 pro p40 pro"
  },
  {
    "id": "g046",
    "marke": "Huawei",
    "modell": "Mate 40 Pro / Mate 50 Pro / Mate 60 Pro",
    "status": "teilweise",
    "hinweis": "Depends on country and version.",
    "such": "huawei mate 40 pro / mate 50 pro / mate 60 pro mate 40 50 60 pro"
  },
  {
    "id": "g047",
    "marke": "Huawei",
    "modell": "P50 Pro / P60 Pro / Pura 70",
    "status": "teilweise",
    "hinweis": "Depends on country and version.",
    "such": "huawei p50 pro / p60 pro / pura 70 p50 p60 pura 70"
  },
  {
    "id": "g048",
    "marke": "Motorola",
    "modell": "Razr 40 / 40 Ultra / 50 / 50 Ultra / 60",
    "status": "ja",
    "hinweis": "",
    "such": "motorola razr 40 / 40 ultra / 50 / 50 ultra / 60 razr falt"
  },
  {
    "id": "g049",
    "marke": "Motorola",
    "modell": "Edge 40 / 40 Pro / 50 / 50 Pro / 60 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "motorola edge 40 / 40 pro / 50 / 50 pro / 60 pro edge 40 50 60 pro"
  },
  {
    "id": "g050",
    "marke": "Motorola",
    "modell": "Moto G (most models)",
    "status": "nein",
    "hinweis": "",
    "such": "motorola moto g (most models) moto g"
  },
  {
    "id": "g051",
    "marke": "OnePlus",
    "modell": "OnePlus 11 / 12 / 13",
    "status": "teilweise",
    "hinweis": "European units have eSIM, some other regions do not.",
    "such": "oneplus oneplus 11 / 12 / 13 oneplus 11 12 13"
  },
  {
    "id": "g052",
    "marke": "OnePlus",
    "modell": "OnePlus Open",
    "status": "ja",
    "hinweis": "",
    "such": "oneplus oneplus open open falt"
  },
  {
    "id": "g053",
    "marke": "OnePlus",
    "modell": "Nord 3 / Nord 4 / Nord 5",
    "status": "teilweise",
    "hinweis": "Depends on the country.",
    "such": "oneplus nord 3 / nord 4 / nord 5 nord 3 4 5"
  },
  {
    "id": "g054",
    "marke": "Oppo",
    "modell": "Find X3 Pro / X5 / X5 Pro / X6 Pro / X7 Ultra / X8 / X8 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "oppo find x3 pro / x5 / x5 pro / x6 pro / x7 ultra / x8 / x8 pro find x3 x5 x6 x7 x8"
  },
  {
    "id": "g055",
    "marke": "Oppo",
    "modell": "Find N2 Flip / N3 / N5",
    "status": "ja",
    "hinweis": "",
    "such": "oppo find n2 flip / n3 / n5 find n2 n3 n5 flip falt"
  },
  {
    "id": "g056",
    "marke": "Oppo",
    "modell": "Reno (most models)",
    "status": "nein",
    "hinweis": "",
    "such": "oppo reno (most models) reno 8 10 12"
  },
  {
    "id": "g057",
    "marke": "Honor",
    "modell": "Magic 4 Pro / Magic 5 Pro / Magic 6 Pro / Magic 7 Pro",
    "status": "ja",
    "hinweis": "",
    "such": "honor magic 4 pro / magic 5 pro / magic 6 pro / magic 7 pro magic 4 5 6 7 pro"
  },
  {
    "id": "g058",
    "marke": "Honor",
    "modell": "Magic V2 / V3 / Vs",
    "status": "teilweise",
    "hinweis": "Depends on the country.",
    "such": "honor magic v2 / v3 / vs magic v2 v3 vs falt"
  },
  {
    "id": "g059",
    "marke": "Honor",
    "modell": "Honor 200 / 400 series",
    "status": "teilweise",
    "hinweis": "Depends on country and version.",
    "such": "honor honor 200 / 400 series honor 200 400"
  },
  {
    "id": "g060",
    "marke": "Sony",
    "modell": "Xperia 10 III Lite",
    "status": "ja",
    "hinweis": "",
    "such": "sony xperia 10 iii lite xperia 10 iii lite"
  },
  {
    "id": "g061",
    "marke": "Sony",
    "modell": "Xperia 1 IV / 1 V / 1 VI / 1 VII",
    "status": "ja",
    "hinweis": "",
    "such": "sony xperia 1 iv / 1 v / 1 vi / 1 vii xperia 1 iv v vi vii"
  },
  {
    "id": "g062",
    "marke": "Sony",
    "modell": "Xperia 5 IV / 5 V",
    "status": "ja",
    "hinweis": "",
    "such": "sony xperia 5 iv / 5 v xperia 5 iv v"
  },
  {
    "id": "g063",
    "marke": "Nothing",
    "modell": "Phone (1) / (2) / (2a) / (3) / (3a)",
    "status": "ja",
    "hinweis": "",
    "such": "nothing phone (1) / (2) / (2a) / (3) / (3a) nothing phone 1 2 3 2a 3a"
  },
  {
    "id": "g064",
    "marke": "Fairphone",
    "modell": "Fairphone 4 / 5 / 6",
    "status": "ja",
    "hinweis": "",
    "such": "fairphone fairphone 4 / 5 / 6 fairphone 4 5 6"
  },
  {
    "id": "g065",
    "marke": "Rakuten",
    "modell": "Rakuten Mini / Big / Big s / Hand / Hand 5G",
    "status": "ja",
    "hinweis": "",
    "such": "rakuten rakuten mini / big / big s / hand / hand 5g rakuten mini big hand"
  },
  {
    "id": "g066",
    "marke": "Microsoft",
    "modell": "Surface Duo / Duo 2 / Surface Pro (LTE)",
    "status": "ja",
    "hinweis": "",
    "such": "microsoft surface duo / duo 2 / surface pro (lte) surface duo pro lte"
  },
  {
    "id": "g067",
    "marke": "Other",
    "modell": "Windows laptops with an LTE/5G module",
    "status": "teilweise",
    "hinweis": "Many devices from 2019 onwards support eSIM, check the model.",
    "such": "other windows laptops with an lte/5g module laptop notebook windows lte 5g"
  }
];
